import { render, staticRenderFns } from "./PaymentComplete.vue?vue&type=template&id=23cb3c43"
import script from "./PaymentComplete.vue?vue&type=script&lang=ts"
export * from "./PaymentComplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports